<template>
  <div>
    <main-header />
    <tabs
      ref="tabs"
      :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
      class="spl-edit-tabs-driver">
      <tab id="defaultFilter" name="Edit/Create Driver">
        <div class="daily-cargo-edit-driver-administration">
          <div class="row">
            <div class="col12">
              <div class="spl-h3 spl-h3--first">
                General Info
              </div>
              <div class="col3">
                <form-label>Tour</form-label>
                <form-filtered-select
                  v-model="dailyCargoDriverData.Flight_ID"
                  :options="routeOptions"
                  :selected-key="dailyCargoDriverData.Flight_ID"
                  placeholder="Tour" />
              </div>
              <div class="col3">
                <form-label>Customers</form-label>
                <customer-multiselect
                  :selected-keys="customers"
                  :limit-height="true"
                  :placeholder="'Filter by customer'"
                  class="spl-export-proof-filter__item"
                  style="grid-column: 2"
                  @valuesSelected="onCustomersSelected" />
              </div>
              <div class="col3">
                <form-label>Countries</form-label>
                <country-multiselect
                  :selected-keys="countries"
                  :limit-height="true"
                  :placeholder="'Filter by country'"
                  class="spl-export-proof-filter__item"
                  style="grid-column: 3"
                  @valuesSelected="onCountriesSelected" />
              </div>
              <div class="col3">
                <form-label>Providers</form-label>
                <form-filtered-select
                  v-model="dailyCargoDriverData.Provider_ID"
                  :options="activeProviderOptions"
                  :selected-key="dailyCargoDriverData.Provider_ID"
                  placeholder="Provider" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col12">
              <div class="spl-h3">
                Driver Info
              </div>
              <div class="col3">
                <form-label>Transport company</form-label>
                <form-input
                  v-model="dailyCargoDriverData.Transporter"
                  :invalid="$v.dailyCargoDriverData.Transporter && $v.dailyCargoDriverData.Transporter.$invalid"
                  placeholder="License company"
                  data-cy="edit-daily-cargo-license-company" />
                <span v-if="$v.dailyCargoDriverData.Transporter && !$v.dailyCargoDriverData.Transporter.$invalid" class="error">Please enter a transport company</span>
              </div>
              <div class="col3">
                <form-label>License number</form-label>
                <form-input
                  v-model="dailyCargoDriverData.License_Number"
                  placeholder="License number"
                  data-cy="edit-daily-cargo-license-company" />
              </div>
              <div class="col3">
                <form-label>Driver Name</form-label>
                <form-input
                  v-model="dailyCargoDriverData.Driver_Name"
                  :invalid="$v.dailyCargoDriverData.Driver_Name && $v.dailyCargoDriverData.Driver_Name.$invalid"
                  placeholder="Driver Name"
                  data-cy="edit-daily-cargo-driver-name" />
                <span v-if="$v.dailyCargoDriverData.Driver_Name && $v.dailyCargoDriverData.Driver_Name.$invalid" class="error">Please choose a drivers name</span>
              </div>
              <div class="col3">
                <form-label>License Plate</form-label>
                <form-input
                  v-model="dailyCargoDriverData.Plate_Number"
                  :invalid="$v.dailyCargoDriverData.Plate_Number && $v.dailyCargoDriverData.Plate_Number.$invalid"
                  placeholder="License Plate"
                  data-cy="edit-daily-cargo-plate-number" />
                <span v-if="$v.dailyCargoDriverData.Plate_Number && !$v.dailyCargoDriverData.Plate_Number.$invalid" class="error">Please enter a plate number</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col12">
              <div class="col3">
                <form-label>Vehicle Type</form-label>
                <form-filtered-select
                  v-model="dailyCargoDriverData.Vehicle_ID"
                  :options="vehicleOptions"
                  :selected-key="dailyCargoDriverData.Vehicle_ID"
                  placeholder="Vehicle" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col12">
              <div class="col3">
                <form-label>Pre Carriage Route</form-label>
                <form-filtered-select
                  v-model="dailyCargoDriverData.PreCarriage_Route_ID"
                  :options="preCarriageRouteOptions"
                  :selected-key="dailyCargoDriverData.PreCarriage_Route_ID"
                  placeholder="PreCarriage Route" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col12">
              <div class="spl-h3">
                Driver Validation
              </div>
              <div class="col3">
                <form-label>Training.11.2.3.9 Valid To</form-label>
                <form-datepicker v-model="dailyCargoDriverData.Training_11_2_3_9_Valid_To" />
              </div>
              <div class="col3">
                <form-label>Training.DGR.PK.7.8 Valid To</form-label>
                <form-datepicker v-model="dailyCargoDriverData.Training_DGR_PK_7_8_Valid_To" />
              </div>
            </div>
          </div>

          <div class="row spl-h3--last">
            <div class="col12">
              <div class="spl-h3">
                Other Info
              </div>
              <div class="col3">
                <form-label>Comments</form-label>
                <form-input
                  v-model="dailyCargoDriverData.Comments"
                  placeholder="Comments"
                  data-cy="edit-daily-cargo-comments" />
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabs>
    <div>
      <daily-cargo-edit-action-bar
        :invalid="$v.$invalid"
        @onSave="handleSave"
        @onCancel="handleCancel" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import Helpers from '@/helpers.vue'
import { required } from 'vuelidate/lib/validators'
import constants from '@/constants'
import moment from 'moment'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      routeLabel: '',
      dailyCargoDriverData: {},
      Training_DGR_PK_7_8_Valid_To: moment().toISOString(true),
      Training_11_2_3_9_Valid_To: moment().toISOString(true),
      customers: [],
      countries: [],
      constants
    }
  },
  validations () {
    return {
      dailyCargoDriverData: {
        ...this.validatedFields
      }
    }
  },
  created () {
    this.dailyCargoDriverData = this.$route.params
    this.customers = this.dailyCargoDriverData.Customer_ID !== '' ? Array.from(this.dailyCargoDriverData.Customer_ID.split(','), Number) : [-1]
    this.countries = this.dailyCargoDriverData.Country_ID !== '' ? Array.from(this.dailyCargoDriverData.Country_ID.split(','), Number) : [-1]
    if (this.dailyCargoDriverData.Training_DGR_PK_7_8_Valid_To) {
      this.Training_DGR_PK_7_8_Valid_To = this.formatDate(this.dailyCargoDriverData.Training_DGR_PK_7_8_Valid_To, false, 'YYYY-MM-DD')
    }
    if (this.dailyCargoDriverData.Training_11_2_3_9_Valid_To) {
      this.Training_11_2_3_9_Valid_To = this.formatDate(this.dailyCargoDriverData.Training_11_2_3_9_Valid_To, false, 'YYYY-MM-DD')
    }
  },
  computed: {
    ...mapState('dailyCargo', ['dailyCargoDriver']),
    ...mapGetters('dailyCargo', ['routeOptions']),
    ...mapGetters('provider', ['activeProviderOptions']),
    ...mapGetters('vehicle', ['vehicleOptions']),
    ...mapGetters('preCarriageRoutes', ['preCarriageRouteOptions']),
    validatedFields () {
      var fields = {}
      if (!this.dailyCargoDriverData.Driver_Name) {
        fields.Driver_Name = { required }
      }
      if (!this.dailyCargoDriverData.Plate_Number) {
        fields.Plate_Number = { required }
      }
      if (!this.dailyCargoDriverData.Transporter) {
        fields.Transporter = { required }
      }
      return fields
    }
  },
  methods: {
    ...mapActions('dailyCargo', ['saveDailyCargoDriver']),
    getRouteLabel (flightId) {
      return this.routeOptions.filter(route => route.value === flightId)[0].label
    },
    onCustomersSelected (customers) {
      this.dailyCargoDriverData.Customer_ID = customers.join(',')
    },
    onCountriesSelected (countries) {
      this.dailyCargoDriverData.Country_ID = countries.join(',')
    },
    onUpdateValue (value) {
      this.dailyCargoDriverData.Driver_ID = value.Driver_ID
    },
    validateAndSend () {
      this.isLoading = true
      this.saveDailyCargoDriver(this.dailyCargoDriverData).then((response) => {
        this.isLoading = false
        this.$router.push('/daily-cargo-general/4')
        this.$forceUpdate()
      }).catch((error) => {
        this.isLoading = false
        messageDialog('Something went wrong: ' + error.ExceptionMessage)
      })
    },
    // *********************** Handle Actionbar *************************
    handleSave () {
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.push('/daily-cargo-general/4')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';

  .spl-edit-tabs-driver {
    background-color: #fff7e7;
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
  .daily-cargo-edit-driver-administration {
    background-color: #fff7e7;
    & .spl-h3 {
      margin-top: 30px;
      margin-bottom: 40px;
      position: relative;

      &::before {
        content: "";
        border-bottom: 3px solid black;
        opacity: 0.3;
        width: 30px;
        position: absolute;
        bottom: -13px;
      }
    }
    & .spl-h3--first {
      padding-top: 30px;
      margin-top: 0px !important;
    }
    & .spl-h3--last {
      padding-bottom: 100px;
    }
    &__date {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      position: relative;

      div {
        background-color: $grey_95;
        border-radius: 5px;
        padding: 3px;
      }

      .spl-checkbox-group__item__label {
        margin-bottom: 10px;
      }
    }

    &__fields, &__postal, &__references, &__weekend-delivery {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      div {
        margin-bottom: 10px;
      }
    }
  }
</style>
